import React from "react";
import * as Mui from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        "& .MuiTypography-root.MuiTypography-h6": {
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
        },
    },
    titleSection: {
        display: "flex",
        flexDirection: "row",
    },
    iconStyle: {
        width: "40px",
        height: "40px",
        marginBottom: "8px",
    },
    title: {
        fontWeight: "bold",
        fontSize: "18px",
    },
    subtitle: {
        fontSize: "14px",
        color: theme.palette.text.primary,
        marginTop: "4px",
    },
    closeButton: {
        padding: "8px",
    },
    content: {
        maxHeight: "70vh",
        overflowY: "auto",
        padding: "16px",
    },
}));

interface DialogModalProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title: string;
    subtitle?: string;
    icon?: any;
    className?: any;
}

const DialogModal: React.FC<DialogModalProps> = ({ open, onClose, title, subtitle, children, icon, className }) => {
    const classes = useStyles();

    return (
        <Mui.Dialog open={open} onClose={onClose} className={className}>
            <Mui.DialogTitle className={classes.modalHeader}>
                <div className={classes.titleSection}>
                    {icon && React.createElement(icon, { className: classes.iconStyle })}
                    <div>
                        <Mui.Typography variant="h6" className={classes.title}>
                            {title}
                        </Mui.Typography>
                        {subtitle && <Mui.Typography className={classes.subtitle}>{subtitle}</Mui.Typography>}
                    </div>
                </div>
                <Mui.IconButton aria-label="close" onClick={onClose} className={classes.closeButton}>
                    <CloseIcon />
                </Mui.IconButton>
            </Mui.DialogTitle>
            <Mui.DialogContent className={classes.content}>{children}</Mui.DialogContent>
        </Mui.Dialog>
    );
};

export default DialogModal;
